import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import axios from "src/utils/axios";
import moment from "moment";

const epoch = {
  year: 1970,
  month: 0,
  date: 1
};

const initialState = {
  chartData: null,
  totalLicenses: 0,
  filters: {
    product: "all",
    range: "lastWeek",
    customRange: {
      start: moment()
        .subtract(1, "weeks")
        .toDate()
        .toString(),
      end: moment()
        .toDate()
        .toString(),
      excludeWeekends: false
    },
    metric: "licensesUsed",
    timeSegmentation: "hourly",
    workHoursOnly: false,
    workHours: {
      start: moment("09:00 AM", "hh:mm a")
        .set(epoch)
        .toDate()
        .toString(),
      end: moment("05:30 PM", "hh:mm a")
        .set(epoch)
        .toDate()
        .toString()
    },
    qos: false,
    qosLevel: 90
  }
};

const slice = createSlice({
  name: "usageChart",
  initialState,
  reducers: {
    getChartData(state, action) {
      const { chartData, totalLicenses } = action.payload;

      state.chartData = chartData;
      state.totalLicenses = totalLicenses;
    },
    getFilters(state, action) {
      const { filters } = action.payload;

      if (_.isEmpty(filters)) {
        return;
      }

      state.filters = filters;
    },
    setFilters(state, action) {
      const { filters } = action.payload;

      state.filters = filters;
    }
  }
});

export const reducer = slice.reducer;

export const getChartData = filters => async dispatch => {
  const response = await axios.post("/api/admin/usage/chart", {
    filters
  });

  dispatch(slice.actions.getChartData(response.data));
};

export const setFilters = filters => async dispatch => {
  dispatch(slice.actions.setFilters({ filters }));
};

export default slice;
